import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    OptimizelyProvider,
    createInstance,
    setLogLevel,
} from '@optimizely/react-sdk';
import {
    useOptimizelyKey,
    useLanguageIso,
} from '~SpectateStore/hooks/clientStateHooks';
import {
    useCountryIso,
} from '~SpectateStore/hooks/userHooks';
import {
    useOptimizelyUserId,
} from '~SpectateStore/hooks/optimizelyHooks';

setLogLevel('error');

const OptimizelyExperiment = ({ children }) => {
    const optimizelyKey = useOptimizelyKey();
    const customerId = useOptimizelyUserId();
    const [optimizely, setOptimizely] = useState();
    const countryIso = useCountryIso();
    const langIso = useLanguageIso();

    useEffect(() => {
        if (optimizelyKey) {
            setOptimizely(createInstance({
                sdkKey: optimizelyKey,
            }));
        }
    }, [optimizelyKey]);

    return <>
        {
            optimizely
            ?
                <OptimizelyProvider
                    optimizely={optimizely}
                    user={{
                        id: `${customerId}`,
                        attributes: {
                            'User_Location': countryIso,
                            'User_Lang': langIso,
                        },
                    }}
                >
                    {children}
                </OptimizelyProvider>
            :
                children
        }
    </>;
};

OptimizelyExperiment.propTypes = {
    children: PropTypes.instanceOf(Object),
};

export default OptimizelyExperiment;
